// ActionButtons.js
import React from 'react';
import PropTypes from 'prop-types';
import ControlledSwitches from '../../Components/Switch/switch.js';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import DisabledEditIcon from '../../Assets/images/svg/dar_pencil_gray.svg';
import DeleteIcon from '../../Assets/images/svg/dar_delete.svg';
import DisabledDeleteIcon from '../../Assets/images/svg/dar_delete_gray.svg';

const ActionButtons = ({
  params,
  hasAccess,
  handleSwitchChange,
  handleEditStaffAugStatusClick,
  handleDeleteClick,
}) => (
  <>
    {handleSwitchChange && (
      <ControlledSwitches
        disabled={!hasAccess('update')}
        checked={Boolean(params.value)}
        handleChange={() => {
          handleSwitchChange(params.row);
        }}
        inputProps={{ 'aria-label': 'enable/disable' }}
        switchCss="switchCss"
        id="staff-aug-status-enable-disable-icon"
      />
    )}
    <button
      disabled={!hasAccess('update')}
      aria-label="Edit"
      className={
        !hasAccess('update')
          ? 'staff-aug-status-action-edit-icon-disabled'
          : 'staff-aug-status-action-edit-icon'
      }
      onClick={() => handleEditStaffAugStatusClick(params.row)}
      id="staff-aug-status-edit-icon"
    >
      <img
        src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
        alt="Edit"
      />
    </button>
    <button
      id="staff-aug-status-delete-icon"
      disabled={!hasAccess('delete')}
      aria-label="Delete"
      className={
        !hasAccess('delete')
          ? 'staff-aug-status-action-delete-icon-disabled'
          : 'staff-aug-status-action-delete-icon'
      }
      onClick={() => handleDeleteClick(params.row)}
    >
      <img
        src={!hasAccess('delete') ? DisabledDeleteIcon : DeleteIcon}
        alt="Delete"
      />
    </button>
  </>
);

ActionButtons.propTypes = {
  params: PropTypes.shape({
    value: PropTypes.any,
    row: PropTypes.object.isRequired,
  }).isRequired,
  hasAccess: PropTypes.func.isRequired,
  handleSwitchChange: PropTypes.func,
  handleEditStaffAugStatusClick: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired,
};

export default ActionButtons;
